
        <ng-content select="[mat-mini-fab]" *ngIf="miniFabVisible"></ng-content>